import React from 'react';
import { connect } from 'react-redux';
import { useLifecycle } from '../../hooks/useLifecycle';
import { ReduxState } from '../../interfaces';
import BarAction from '../shared/barAction';
import * as BarButtons from '../shared/barActionButtons';
import { Groups, ActionButton } from '../../models';

interface StateProps {
  selectedKeys: string[];
}
type IProps = StateProps;

const ActionsBar: React.FC<IProps> = (props) => {
  useLifecycle('Customers Datatable Actions');

  const hasSelectedItems: boolean =
    props.selectedKeys && props.selectedKeys.length > 0;

  const downloadRoot = BarButtons.downloadRoot();
  const downloadOptions: ActionButton[] = hasSelectedItems
    ? [BarButtons.downloadSelected(props.selectedKeys, Groups.CUSTOMERS)]
    : [];

  return (
    <div className="datatable__actions__container">
      <BarAction items={downloadOptions} root={downloadRoot} />
    </div>
  );
};

const mapStateToProps = (state: ReduxState): StateProps => ({
  selectedKeys: state.customersState.selection.selectedKeys,
});

export default connect(mapStateToProps)(ActionsBar);
